"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "accessControlDomainTest", {
  enumerable: true,
  get: function () {
    return _domainUtils.accessControlDomainTest;
  }
});
Object.defineProperty(exports, "formatUrlDomain", {
  enumerable: true,
  get: function () {
    return _domainUtils.formatUrlDomain;
  }
});
Object.defineProperty(exports, "getDomainInfos", {
  enumerable: true,
  get: function () {
    return _domainUtils.getDomainInfos;
  }
});
Object.defineProperty(exports, "getDomains", {
  enumerable: true,
  get: function () {
    return _domainUtils.getDomains;
  }
});
Object.defineProperty(exports, "hostRelativeReplaceAll", {
  enumerable: true,
  get: function () {
    return _domainUtils.hostRelativeReplaceAll;
  }
});
Object.defineProperty(exports, "isForeignLink", {
  enumerable: true,
  get: function () {
    return _domainUtils.isForeignLink;
  }
});
var _domainUtils = require("./otherPackage/domainUtils");